<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="ix-table-box mb-3">
                    <table class="ix-table ix-table-sm">
                        <thead>
                        <tr>
                            <th>Numéro</th>
                            <th>Montant affecté TTC</th>
                            <th class="text-right">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(expense, index) in expenses" v-if="!loading">
                            <td>
                                {{ expense.full_designation }}
                                <input type="hidden" :name="'expenses[' + index + '][id]'" v-model="expense.id" required>
                                <input type="hidden" :name="'expenses[' + index + '][full_designation]'" v-model="expense.full_designation" required>
                            </td>
                            <td>
                                <div class="input-group input-group-sm" style="max-width: 300px">
                                    <input type="number" class="form-control text-right" :name="'expenses[' + index + '][amount]'" v-model="expense.amount" required step="0.01" @blur="updateValidationRules">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                                    </div>
                                </div>
                            </td>
                            <td class="text-right">
                                <button type="button" class="btn btn-sm transparent" @click="deleteRow(index)">
                                    <i class="far fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="loading">
                            <td colspan="3" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </td>
                        </tr>
                        <tr v-show="!loading">
                            <td colspan="3">
                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="expenseSearchInput" type="text" v-model="expense">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";

    export default {
        name: 'expense-bill-selector',
        props: ['route', 'oldExpenses'],
        data() {
            return {
                loading: true,
                expense: null,
                expenses: [],
            };
        },
        methods : {
            addRow: function (expense) {
                if (this.getCurrentSelectedExpensesId().includes(expense.id) == false) {
                    this.expenses.push({
                        id: expense.id,
                        full_designation: expense.full_designation,
                        amount: expense.amount ? expense.amount : (expense.pivot ? expense.pivot.amount : expense.total_remaining)
                    })
                }
            },
            deleteRow: function (index) {
                this.expenses.splice(index, 1)
                this.updateValidationRules()
                if (this.expenses.length == 0) {
                    this.addRow()
                }
            },
            getCurrentSelectedExpensesId: function() {
                return this.expenses.map(expense => expense.id);
            },
            updateValidationRules: function() {
                var total = 0;
                this.expenses.forEach(expense => total += parseFloat(expense.amount));

                $("#total_ttc").attr({
                    "min" : total
                });
            }
        },
        mounted(){
            $("#expenseSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.route,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedExpensesId().join(';'), 'hasremaining': true, 'valid': 'only' },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.full_designation,
                                    value: item.full_designation,
                                    formatted_total_remaining: this.currency(item.total_remaining)
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = (ul, item) => {
                        var html = `<div class="d-flex align-items-center justify-content-between">
                                      <span>${item.full_designation} (${item.company.name})</span>
                                      <span>Restant facturable : ${item.formatted_total_remaining}</span>
                                    </div>`;

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.expense = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addRow(item.item)

                        $(e.target).val("")
                        this.expense = null
                    }
                }
            }).focus(() => {
                $("#expenseSearchInput").autocomplete("search", '');
            });

            const jsonExpenseBackup = JSON.parse(this.oldExpenses)
            if (Array.isArray(jsonExpenseBackup)) {
                if (jsonExpenseBackup.length > 0) {
                    jsonExpenseBackup.forEach(expense => {
                        this.addRow(expense)
                    })
                }
            }
            this.loading = false
        }
    }
</script>
